:host {
  @apply block flex-1 min-w-[1px] w-full;
}
